import { Component, Input } from '@angular/core';
import { ServiceNames } from 'src/app/layouts/full/shared/Enums';
import { SharedModule } from 'src/app/layouts/full/shared/shared.module';
import { ModalViewPricingDetailsService } from 'src/app/services/modal-view-pricing-details.service';

export type ProductDetails = {
  title: string,
  prices?: {
    units: string,
    pricePerUnit: number
  }[],
  image?: string,
  video?: string,
  description?: string,
  serviceName?: ServiceNames,
  rangedPrice?: boolean
}

export type ThreeDDesignProducts = {
  insoles: ProductDetails,
  afo: ProductDetails,
  spinalBrace: ProductDetails
}

export type ThreeDSubscriptions = {
  basic: ProductDetails,
  advanced: ProductDetails,
  pro: ProductDetails
}

export const ThreeDSubscriptions: ThreeDSubscriptions = {
  basic: {
    title: "3D Basic",
    prices: [
      { units: '1 - 100', pricePerUnit: 2 },
      { units: '101 - 200', pricePerUnit: 1.5 },
      { units: '201 - 1000', pricePerUnit: 1.1 },
      { units: '1001 - 3000', pricePerUnit: 0.9 },
      { units: '3001 - 5000', pricePerUnit: 0.8 },
      { units: '+5001', pricePerUnit: 0.7 },
    ]
  },
  advanced: {
    title: "3D Advanced",
    prices: [
      { units: '1 - 10', pricePerUnit: 4 },
      { units: '11 - 50', pricePerUnit: 3 },
      { units: '51 - 100', pricePerUnit: 2.20 },
      { units: '101 - 200', pricePerUnit: 2 },
      { units: '+201', pricePerUnit: 1.6 },
    ]
  },
  pro: {
    title: "3D Pro",
    prices: [
      { units: '1 - 20', pricePerUnit: 8 },
      { units: '21 - 50', pricePerUnit: 6 },
      { units: '51 - 100', pricePerUnit: 5.6 },
      { units: '101 - 200', pricePerUnit: 4.8 },
      { units: '201 - 1000', pricePerUnit: 4 },
      { units: '+1001', pricePerUnit: 3.5 },
    ]
  }
}

export const ThreeDProducts: ThreeDDesignProducts = {
  afo: {
    title: 'THREE_D_AFO_DESIGN',
    prices: [
      { units: '1 - 10', pricePerUnit: 25 },
      { units: '11 - 50', pricePerUnit: 18 },
      { units: '51 - 100', pricePerUnit: 17.50 },
      { units: '101 - 150', pricePerUnit: 16.25 },
      { units: '151 - 200', pricePerUnit: 15 },
      { units: '+201', pricePerUnit: 12.5 },
    ],
    description: 'AFO_DESCRIPTION',
    video: "assets/videos/demo-afo.mp4",
    serviceName: ServiceNames.ThreeDAfoDesign,
    rangedPrice: true
  },
  spinalBrace: {
    title: 'THREE_D_SPINAL_BRACE_DESIGN',
    prices: [
      { units: '1 - 20', pricePerUnit: 80 },
      { units: '21 - 50', pricePerUnit: 60 },
      { units: '51 - 100', pricePerUnit: 56 },
      { units: '101 - 200', pricePerUnit: 48 },
      { units: '+201', pricePerUnit: 40 },
    ],
    description: 'SPINAL_BRACE_DESCRIPTION',
    video: "assets/videos/demo-spinal-brace.mp4",
    serviceName: ServiceNames.ThreeDSpinalBraceDesign,
    rangedPrice: true
  },
  insoles: {
    title: 'THREE_D_INSOLES_DESIGN',
    prices: [
      { units: '1 - 50', pricePerUnit: 9 },
      { units: '51 - 100', pricePerUnit: 6.75 },
      { units: '101 - 1000', pricePerUnit: 4.50 },
      { units: '1001 - 3000', pricePerUnit: 3.60 },
      { units: '3001 - 5000', pricePerUnit: 2.70 },
      { units: '+5001', pricePerUnit: 1.80 }
    ],
    description: 'INSOLES_DESCRIPTION',
    video: "assets/videos/3D_Design_Engine.mp4",
    serviceName: ServiceNames.ThreeDInsolesDesign,
    rangedPrice: true
  }
}

@Component({
  selector: 'app-modal-pricing-details',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './modal-pricing-details.component.html',
  styleUrl: './modal-pricing-details.component.scss'
})
export class ModalPricingDetailsComponent {
  product: ProductDetails
  displayModal: boolean = true;

  constructor(
    public modalViewPricingDetailsService: ModalViewPricingDetailsService
  ) { }

  @Input() productInput: ProductDetails

}
